import styled from 'styled-components';
import { Container } from 'rsuite';

export const StyledContainer = styled(Container)`
  padding: 10px;
  height: calc(100vh - 60px);
  background-color: ${({ theme }) => theme.colors.background};
  overflow-y: auto;
  max-width: 1600px;
  margin: 0 auto;
`;
